import { makeStyles } from '@material-ui/core/styles'
export default makeStyles(() => ({
  dropZone: {
    cursor: 'pointer',
    border: 'dashed darkgray',
    minHeight: 100
  },
  isDragActive: {
    backgroundColor: 'lightgray'
  }
}))
